<template>
  <div class="container">
    <div class="flex">
      <!--PRIMERA SECCION-->
      <div class="profile">
        <div class="container__profile">
          <div class="container__imagen">
            <img :src="ellipseImage" style="width: 160px" alt="perfil" />
            <div class="bottom__profile">
              <img v-if="imageSrc" :src="imageSrc" class="image-record" alt="profile image" />
              <div
                v-else
                class="background__profile"
                :class="record.role.name === 'Agente' ? 'background__agent' : ''"
              >
                <img
                  v-if="record.icon"
                  class="user__agente"
                  :class="record.role.name != 'Agente' ? 'user__profile' : ''"
                  :src="getProfileImage(record?.icon || iconDefault)"
                  alt="perfil"
                />
              </div>
            </div>
          </div>
          <p class="info--name">{{ record.first_name }} {{ record.last_name }}</p>
          <p class="info">
            <a-tooltip>
              <template #title>Rol</template>
              <img src="@/app/users/assets/profiles/icon-user.png" alt="profile" />
            </a-tooltip>
            {{ record.role.name }}
          </p>
          <p class="info">{{ record.email }}</p>
          <!--TIPO DE REGISTRO-->
          <em v-if="registrationTypeTitle" class="container__registration-type">{{
            registrationTypeTitle
          }}</em>
          <div class="line-yellow"></div>
        </div>
      </div>
      <!--SEGUNDA SECCION-->
      <CustomScrollbar auto height="550px" class="form">
        <a-form ref="formRef" :model="formState" layout="vertical">
          <h4>Información personal</h4>

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item class="form__item" label="Nombres">
                <a-input
                  v-model:value="formState.first_name"
                  @change="handleInput"
                  :disabled="fromTickets || !canEdit"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="form__item" label="Apellidos">
                <a-input
                  v-model:value="formState.last_name"
                  placeholder="Escribir apellido"
                  @change="handleInput"
                  :disabled="fromTickets || !canEdit"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item class="form__item" label="Correo electrónico">
                <a-input
                  :disabled="update"
                  :value="record.email"
                  placeholder="Escribir correo electrónico"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <p class="text__phone">Celular</p>
              <a-row :gutter="8" type="flex">
                <a-form-item class="form__item">
                  <a-input
                    v-model:value="formState.phone"
                    placeholder="Escribir número del celular"
                    @change="handleInput"
                    :disabled="fromTickets || !canEdit"
                  >
                    <template #addonBefore>
                      <a-select
                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                        v-model:value="code_phone"
                        @change="handleInput"
                        :disabled="fromTickets || !canEdit"
                      >
                        <a-select-option v-for="country in countries" :key="country.id">
                          <img class="flag" :src="`${country.url_flag}`" alt="pais" />
                        </a-select-option>
                      </a-select>
                    </template>
                  </a-input>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item class="form__item" label="Tipo de Documento">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.type_document"
                  class="form__item"
                  placeholder="Seleccionar tipo de documento"
                  @change="handleSelectChange"
                  :disabled="fromTickets || !canEdit"
                >
                  <a-select-option :value="DocumentType.dni"> DNI </a-select-option>
                  <a-select-option :value="DocumentType.ce">
                    Carnet de Extranjeria
                  </a-select-option>
                  <a-select-option :value="DocumentType.pasaporte"> Pasaporte </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="form__item" label="Número de Documento">
                <a-input
                  v-model:value="formState.document_number"
                  placeholder="Escribir número de documento"
                  @change="handleInput"
                  :disabled="fromTickets || !canEdit"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item class="form__item" label="Sexo">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.sex"
                  placeholder="Seleccionar sexo"
                  @change="handleSelectChange"
                  :disabled="fromTickets || !canEdit"
                >
                  <a-select-option :key="1" :value="1">Hombre</a-select-option>
                  <a-select-option :key="2" :value="2">Mujer</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="form__item" label="Fecha de nacimiento">
                <a-date-picker
                  class="form__item--date"
                  v-model:value="formState.birthdate"
                  placeholder="-- / -- / ----"
                  format="DD/MM/YYYY"
                  valueFormat="YYYY-MM-DD"
                  :disabled-date="disabledDate"
                  :show-today="false"
                  :default-picker-value="defaultYounger"
                  @change="handleInput"
                  :disabled="fromTickets || !canEdit"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item class="form__item form__item--large" label="Dirección">
                <a-input
                  v-model:value="formState.address"
                  placeholder="Escribir dirección"
                  @change="handleInput"
                  :disabled="fromTickets || !canEdit"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="form__item" label="País de residencia">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.country"
                  placeholder="Seleccionar país de residencia"
                  @change="handleInput"
                  :disabled="fromTickets || !canEdit"
                >
                  <a-select-option v-for="country in countries" :key="country.id">
                    {{ country.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <h4>Información en {{ ProductName }}</h4>

          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-item class="form__item form__item--large" label="Correo">
                <a-input :value="record.email" :disabled="true">
                  <template #suffix>
                    <CopyButton :value="record.email" />
                  </template>
                </a-input>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item class="form__item generate__password" name="generate-password">
                <template #label>
                  <span class="label">
                    <span> Contraseña </span>

                    <a-button type="link" class="button button-label" @click="generatePassword">
                      Generar contraseña
                    </a-button>
                  </span>
                </template>

                <a-input
                  v-model:value="password"
                  placeholder="Nueva contraseña"
                  @change="handleInput"
                  :disabled="!password"
                >
                  <template #suffix>
                    <CopyButton :value="password" />
                  </template>
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24" v-if="!record.is_owner">
            <a-col :span="24">
              <a-form-item class="form__item" label="Tipo de perfil asignado">
                <a-select
                  :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                  v-model:value="formState.profile"
                  :disabled="fromTickets || record.status === 2 || record.role == 'Owner'"
                  @change="handleChangeProfile(record)"
                >
                  <a-select-option v-for="profile in profiles" :key="profile.id">
                    {{ profile.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </CustomScrollbar>
    </div>
    <div class="footer">
      <template v-if="fromTickets">
        <a-button class="footer__back" style="position: absolute; right: 0" @click="handleCancel">
          Ocultar
        </a-button>
      </template>

      <template v-else>
        <div v-if="update" class="control__user">
          <!-- <a v-if="!record.is_owner" @click="handleDisabledUser">
            <span class="disabledUser" v-if="record.status === 1">Inactivar usuario</span>
          </a> -->
          <!-- <a
            v-if="!record.is_owner && record.status === 2"
            @click="handleConfirmationReactivate(record)"
            ><span class="disabledUser">Reactivar usuario</span>
          </a> -->
          <a-tooltip>
            <template #title v-if="user.id == record.id">
              No puedes eliminar tu propia cuenta. Solicita a otro usuario, 
              que sea owner o administrador, que realice esta acción.
            </template>
            <a type="link" :disabled="user.id == record.id" 
              v-if="!record.is_owner" @click="handleDeleteUser"
            >
                <span 
                  class="deleteUser" 
                  :class="user.id == record.id ? 'deleteUser_disabled' : ''">
                  Eliminar usuario
                </span>
            </a>
          </a-tooltip>
        </div>
        <div>
          <a-button
            class="footer__back"
            @click="handleCancel"
            v-if="record.status === UserStatus.active"
          >
            {{ showSave ? "Cancelar" : "Cerrar" }}
          </a-button>
          <a-button
            class="footer__next"
            type="primary"
            @click="handleOk"
            v-if="record.status === UserStatus.active && showSave"
            :disabled="isDisabled"
            :loading="loading"
          >
            Guardar cambios
          </a-button>
        </div>
      </template>
    </div>
    <!-- <inactive-user-modal
      v-if="record.role?.name === 'Administrador' && record.assigned_contacts === 0"
      :visible="visibleInactive"
      :record="record"
      @onCancel="handleCancelInactive"
      @onCloseModal="handleCancel"
    ></inactive-user-modal>
    <inactive-agent-modal
      v-if="record.role?.name === 'Agente' && record.assigned_contacts === 0"
      :visible="visibleInactive"
      :record="record"
      @onCancel="handleCancelInactive"
      @onCloseModal="handleCancel"
    ></inactive-agent-modal> -->
    <delete-user-modal
      v-if="record.role?.name === 'Administrador' && record.assigned_contacts === 0"
      :visible="visibleDelete"
      :record="record"
      type="User"
      @onCancel="handleCancelDelete"
      @onCloseModal="handleCancel"
    ></delete-user-modal>
    <delete-user-modal
      v-if="record.role?.name === 'Agente' && record.assigned_contacts === 0"
      :visible="visibleDelete"
      :record="record"
      @onCancel="handleCancelDelete"
      @onCloseModal="handleCancel"
    ></delete-user-modal>
    <delete-agent-assigned
      v-if="record.assigned_contacts > 0"
      :visible="visibleDelete"
      :record="record"
      @onCancel="handleCancelDelete"
      @onCloseModal="handleCancel"
    ></delete-agent-assigned>

    <!-- <inactive-agent-assigned
      v-if="record.assigned_contacts > 0"
      :visible="visibleInactive"
      :record="record"
      @onCancel="handleCancelInactive"
      @onCloseModal="handleCancel"
    ></inactive-agent-assigned> -->
  </div>
</template>

<script>
import { defineComponent, reactive, ref, createVNode, computed } from "vue";
import { useStore } from "vuex";
import { Modal } from "ant-design-vue";
import { QuestionCircleOutlined } from "@ant-design/icons-vue";

import { humanDateFormat, ProductName } from "@/app/shared/utils/constants";
import { DocumentType, UserStatus, RolTypes } from "@/app/shared/utils/enums";
import { disabledYounger, defaultYounger } from "@/app/shared/utils/dates";
import { generateRandomString } from "@/app/shared/utils/helpers";
import { REGISTRATION_TYPES } from "@/app/users/utils/constants";

// import InactiveUserModal from "@/app/users/components/modals/InactiveUserModal";
// import InactiveAgentModal from "@/app/users/components/modals/InactiveAgentModal";
import DeleteUserModal from "@/app/users/components/modals/DeleteUserModal.vue";
import DeleteAgentAssigned from "@/app/users/components/modals/DeleteAgentAssigned.vue";
// import InactiveAgentAssigned from "@/app/users/components/modals/InactiveAgentAssigned";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import CopyButton from "@/app/shared/components/buttons/CopyButton.vue";

import crownImage from "@/app/settings/assets/profile/crown.svg?url";
import ellipseImage from "@/app/settings/assets/profile/ellipse.svg?url";

export default defineComponent({
  name: "UsersInviteModal",
  components: {
    // InactiveUserModal,
    DeleteUserModal,
    // InactiveAgentModal,
    DeleteAgentAssigned,
    // InactiveAgentAssigned,
    CustomScrollbar,
    CopyButton,
  },
  props: {
    record: {
      type: Object,
      default: null,
    },
    update: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
    showSave: {
      type: Boolean,
      default: false,
    },
    fromTickets: Boolean,
  },
  setup(props) {
    const visibleInactive = ref(false);
    const visibleDelete = ref(false);
    const previousSelectedProfile = ref(props.record.profile);
    const profilesTypes = RolTypes;

    const handleDisabledUser = () => {
      visibleInactive.value = true;
    };
    const handleDeleteUser = () => {
      if (user.id != record.id) visibleDelete.value = true;
    };
    const handleCancelInactive = () => {
      visibleInactive.value = false;
    };
    const handleCancelDelete = () => {
      visibleDelete.value = false;
    };
    const store = useStore();
    const formRef = ref();
    const code_phone = ref(props.record?.code_phone);
    let formState;

    if (props.update) {
      formState = reactive({
        first_name: props.record.first_name,
        last_name: props.record.last_name,
        type_document: props.record.type_document,
        document_number: props.record.document_number,
        sex: props.record.sex || undefined,
        birthdate: props.record.birthdate,
        country: props.record.country,
        address: props.record.address,
        phone: props.record.phone,
        profile: props.record.profile,
      });
    } else {
      const user = store.getters["getUser"];

      if (user.code_phone != undefined) {
        code_phone.value = user.code_phone;
      } else {
        code_phone.value = 1;
      }
    }

    /**
     * Password generation
     */

    const password = ref(props.record.token);

    // COMPUTED
    const registrationTypeTitle = computed(() => {
      const type = props.record?.registration_type;
      if (!type) return null;
      return REGISTRATION_TYPES[type].title;
    });

    const showFieldEmailInSectionPersonal = computed(() => {
      const type = props.record?.registration_type;
      if (!type) return null;
      return REGISTRATION_TYPES[type].show_field_email_in_personal;
    });

    return {
      formRef,
      formState,
      code_phone,
      handleDisabledUser,
      handleDeleteUser,
      visibleInactive,
      visibleDelete,
      handleCancelInactive,
      handleCancelDelete,
      previousSelectedProfile,
      profilesTypes,
      DocumentType,
      password,
      registrationTypeTitle,
      showFieldEmailInSectionPersonal,
      ProductName,
      ellipseImage,
    };
  },
  data() {
    return {
      dateBuf: true,
      UserStatus,
      humanDateFormat,
      disabledYounger,
      defaultYounger,
      bodyStyle: {
        height: "400px",
      },
      isFormEdited: false,
    };
  },
  computed: {
    imageSrc() {
      return this.record.picture;
    },
    imageDefault() {
      const profile = this.record?.icon;
      let url = "";
      if (profile === "") {
        url = crownImage;
      } else {
        url = getProfileImage(profile);
      }
      return url;
    },
    countries() {
      return this.$store.getters["getAllCountries"];
    },
    usersInfo() {
      return this.$store.getters["getUsersInfo"];
    },
    profiles() {
      return this.$store.getters["getProfileList"];
    },
    isDisabled() {
      return this.formState.profile === this.record.profile && !this.isFormEdited;
    },
    iconDefault() {
      return "smile.svg";
    },
    user() {
      return this.$store.getters["getDataUser"];
    },
  },
  created() {
    this.$store.dispatch("fetchAllProfiles");
  },
  methods: {
    getProfileImage(profile) {
      return new URL(`../../assets/profiles/${profile}`, import.meta.url).href;
    },
    colorStatus(status) {
      return status === UserStatus.active ? "green" : "red";
    },
    handleInput() {
      this.isFormEdited = true;
      this.$emit("onUpdate");
    },
    async generatePassword() {
      this.password = generateRandomString(22);
      this.handleInput();
    },
    handleChangeProfile(item) {
      const currentRole = this.profiles.find((profile) => profile.id == item.profile);
      const newRole = this.profiles.find((profile) => profile.id == this.formState.profile);
      console.log(newRole);
      if (
        currentRole.role == this.profilesTypes.agent &&
        newRole.role == this.profilesTypes.administrator
      ) {
        this.handleConfirmationAdmin(newRole.name);
      } else if (
        currentRole.role == this.profilesTypes.administrator &&
        newRole.role == this.profilesTypes.agent
      ) {
        this.handleConfirmationAgent(newRole.name);
      } else {
        this.$emit("onUpdate");
      }
    },
    async handleReactiveUser() {
      try {
        const body = {
          status: UserStatus.active,
        };
        await this.$store.dispatch("updateUser", {
          id: this.record.id,
          params: body,
        });
      } catch (error) {
        this.$message.error("El correo ya se encuentra registrado", 10);
      }
      this.$emit("updateTable");
      this.$emit("onCloseModal");
    },
    handleSelectChange() {
      this.$emit("onUpdate");
    },
    disabledDate(current) {
      return disabledYounger(current);
    },
    handleOk() {
      this.formRef
        .validateFields()
        .then(() => {
          const data = { ...this.formState };
          const body = {};

          for (const key in data) {
            if (data[key]) body[key] = data[key];
          }

          if (body.profile === this.record.profile) delete body.profile;
          if (this.password) body.token = this.password;

          this.$emit("handleOk", body);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleConfirmationAdmin(name) {
      Modal.confirm({
        title: `¿Estás seguro de cambiar el perfil de este usuario a “${name}”?`,
        content:
          "Recuerda que el perfil seleccionado tiene rol de “Administrador”, por lo que tendrá mayores privilegios y acceso a la plataforma según el rol configurado en el perfil seleccionado.",
        icon: createVNode(QuestionCircleOutlined),
        centered: true,
        okText: "Cambiar",
        cancelText: "Cancelar",
        onOk: () => {
          this.$emit("onUpdate");
        },
        onCancel: () => {
          this.formState.profile = this.previousSelectedProfile;
        },
      });
    },
    handleConfirmationAgent(name) {
      Modal.confirm({
        title: `¿Estás seguro de cambiar el perfil de este usuario a “${name}”?`,
        content:
          "Recuerda que el perfil seleccionado tiene rol de “Agente”, por lo que perderá privilegios y accesos a la plataforma según el rol configurado en el perfil seleccionado.",
        icon: createVNode(QuestionCircleOutlined),
        centered: true,
        okText: "Cambiar",
        cancelText: "Cancelar",
        onOk: () => {
          this.$emit("onUpdate");
        },
        onCancel: () => {
          this.formState.profile = this.previousSelectedProfile;
        },
      });
    },
    handleConfirmationReactivate(record) {
      this.$confirm({
        title: `¿Estás seguro de reactivar a ${record.first_name} ${record.last_name}?`,
        content:
          "Recuerda que el usuario podrá volver a acceder a la plataforma y se consumirá un nuevo slot.",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleReactiveUser(),
        centered: true,
        okText: "Reactivar",
        cancelText: "Cancelar",
        onCancel: () => {
          this.visible = false;
        },
      });
    },
    handleCancel() {
      this.$emit("handleCancel");
    },
  },
});
</script>

<style lang="sass" scoped>
.flag
  width: 20px
  margin-bottom: 2px

.form
  width: 60%
  padding: 0 20px
  &__item--date
    width: 100%

.status__contact
  font-weight: 600

.footer
  display: flex
  justify-content: space-between
  position: absolute
  left: 0
  width: 100%
  height: 56px
  bottom: 0
  background: $white
  align-items: center
  border-top: 1px solid $gray-5
  border-radius: 0px 0px 4px 4px
  &__next
    margin-right: 1rem
  &__back
    margin-right: 1rem

.control__user
  margin-left: 10px
  & a
    margin-left: 10px

.disabledUser
  // color: $gray-7

.deleteUser
  color: $red-6
  &_disabled
    color: $gray-7

:deep(.ant-calendar-picker)
  width: 100%

.flex
  display: flex
  justify-content: space-between

.profile
  text-align: center
  display: flex
  flex-direction: column
  justify-content: center

.line-yellow
  height: 10px
  background: $yellow-6
  width: 308px
  border-radius: 5px
  margin-top: 40px

.state
  margin-top: -30px
  margin-bottom: 30px
  text-align: initial

.container__profile
  margin-top: -23px
  margin-left: 16px

.info
  margin-bottom: 10px
  &--name
    font-size: 16px
    font-weight: 600
    margin-bottom: 10px
    margin-top: 14px

.container__inactive
  text-align: center

.image__inactive
  margin-bottom: 10px

.image__delete
  margin-bottom: 10px

.text__alert
  font-size: 16px
  font-weight: 600

.text
  margin-bottom: 20px

.label
  display: flex
  align-items: center
  justify-content: space-between
  width: 100%

:deep(.generate__password .ant-form-item-label)
  width: 100%

:deep(label[for='form_item_generate-password'])
  width: 100% !important

.button
  padding: 0

  &__disabled
    margin-top: 10px

  &-label
    height: auto
    line-height: 20px

.strong
  font-weight: 600

.text__phone
  margin-bottom: 8px
.bottom__profile
  margin-top: -126px
  width: 95px
  height: 95px
  margin-inline: auto
  border-radius: 50%
  display: flex
  justify-content: center
  & > img
    display: block
    width: 50%
.image-record
  width: 100% !important
  border-radius: 50%
  height: 100%

.container__imagen
  margin-bottom: 40px

.user__agente
  width: 90px
  height: 55px
  margin: 6px
  filter: invert(55%) sepia(46%) saturate(1606%) hue-rotate(351deg) brightness(105%) contrast(96%)

.user__profile
  width: 90px
  height: 55px
  margin: 6px
  filter: invert(62%) sepia(84%) saturate(1521%) hue-rotate(178deg) brightness(103%) contrast(99%)

.background__profile
  background-color: rgb(230, 247, 255)
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px

.background__agent
  background: #FFF6E2
  border-radius: 50%
  display: flex
  align-items: center
  margin-right: 3px

.container__registration-type
  color: $text-tertiary
</style>
